import React from 'react';
import Hero from '../components/Hero';
import Categories from '../components/Categories';
import FeaturedProducts from '../components/FeaturedProducts';
import FeaturedTicker from '../components/FeaturedTicker';
import BrandPromise from '../components/BrandPromise';
import B2BCTA from '../components/B2BCTA';
import { useSettings } from '../context/SettingsContext';
import { visibilityClass } from '../lib/visibility';

const Home = () => {
  const { settings } = useSettings();
  // Settings load asynchronously — until then, render nothing rather than flashing
  // sections that the admin has hidden.
  if (!settings) return <main className="bg-[#F8FAFC] min-h-screen" />;

  const tickerEnabled =
    settings.show_featured_card !== false &&
    settings.featured_display_mode === 'ticker' &&
    (settings.featured_slides?.length || 0) > 0;

  return (
    <main className="bg-[#F8FAFC]">
      <div className={visibilityClass(settings, 'show_hero')}><Hero /></div>
      {tickerEnabled && (
        <div className={visibilityClass(settings, 'show_featured_card')}>
          <FeaturedTicker
            slides={settings.featured_slides}
            speed={settings.ticker_speed ?? 80}
            direction={settings.ticker_direction || 'left'}
            height={settings.ticker_height ?? 180}
            gap={settings.ticker_gap ?? 16}
            itemWidth={settings.ticker_item_width ?? 320}
            marginTop={settings.ticker_margin_top ?? 24}
            marginBottom={settings.ticker_margin_bottom ?? 24}
            background={settings.ticker_background || '#ffffff'}
          />
        </div>
      )}
      <div className={visibilityClass(settings, 'show_categories')}><Categories /></div>
      <div className={visibilityClass(settings, 'show_featured_products')}><FeaturedProducts /></div>
      <div className={visibilityClass(settings, 'show_brand_promise')}><BrandPromise /></div>
      <div className={visibilityClass(settings, 'show_b2b_cta')}><B2BCTA /></div>
    </main>
  );
};

export default Home;
